import Modal from '../Modal';
import styles from './ConfirmStatusModal.module.scss';
import { ReactComponent as WalletIcon } from '../../../assets/svg/icons/portafogli.svg';
import { Button } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import clx from 'classnames';

/**
 * targetStatus: 'pagato' | 'da_pagare'
 * Colors icon, status label and confirm button to match the destination status.
 */
const ConfirmStatusModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  content,
  action,
  targetStatus,
  width = '450px',
}) => {
  const { t } = useTranslation();
  const isPaid = targetStatus === 'pagato';
  const statusLabel = isPaid
    ? t('settings.expenses.status.paid')
    : t('settings.expenses.status.due');
  const statusClass = isPaid ? styles.status_paid : styles.status_due;

  return (
    <Modal
      width={width}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      centered
    >
      <div className={styles.modal__content}>
        <WalletIcon
          className={clx(styles.icon, {
            [styles.icon_paid]: isPaid,
            [styles.icon_due]: !isPaid,
          })}
        />
        <div className={styles.title}>
          {title || (
            <Trans
              i18nKey="settings.expenses.confirmMarkStatus"
              values={{ status: statusLabel }}
              components={{
                status: <span className={statusClass} />,
              }}
            />
          )}
        </div>
        {content && <div className={styles.content}>{content}</div>}
        <div className={styles.modal__actions}>
          <Button
            className={styles.cancel_button}
            onClick={() => setIsModalOpen(false)}
          >
            {t('common.actions.cancel')}
          </Button>
          <Button
            className={clx(styles.confirm_button, {
              [styles.confirm_paid]: isPaid,
              [styles.confirm_due]: !isPaid,
            })}
            onClick={action}
          >
            {t('common.actions.confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmStatusModal;
